export default __webpack_public_path__ + "static/media/mail_icon.a71e16fc.svg";